// extracted by mini-css-extract-plugin
module.exports = {"content":"ModalGetNewVersion_content__2s1-1","buttonStyle":"ModalGetNewVersion_buttonStyle__3Uj62"};